export default {
  inserted (el, binding) {
    const {
      callback,
      options = {},
      once = false
    } = binding.value

    const defaultOptions = {
      threshold: 0.5,
      root: null,
      rootMargin: '0px'
    }

    const observerOptions = { ...defaultOptions, ...options }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        const isVisible = entry.isIntersecting
        callback(isVisible, entry)

        if (once && isVisible) {
          obs.unobserve(el)
        }
      })
    }, observerOptions)

    observer.observe(el)
    el._io = observer
  },

  unbind (el) {
    if (el._io) {
      el._io.disconnect()
      delete el._io
    }
  }
}
